<div class="sidebar-wrapper">
  <div class="logo">
    <a href="https://www.planinternational.be/nl" class="simple-text logo-mini">
      <div class="logo-image-small">
        <img src="assets/img/plan-international-logo.jpg" alt="Plan International logo" />
      </div>
    </a>
    <a
      href="https://www.planinternational.be/nl"
      class="simple-text logo-normal"
      >
      Plan International
    </a>
  </div>
  <ul class="nav">
    @for (menuItem of menuItems(); track menuItem) {
      <li
        routerLinkActive="active"
        [class]="menuItem.class"
        >
        <a
          [routerLink]="[menuItem.path]"
          [attr.data-testid]="'sidebar-link-' + menuItem.title.toLowerCase()"
        >
          <i class="nc-icon {{ menuItem.icon }}"></i>
          <p>{{ menuItem.title }}</p>
        </a>
      </li>
    }
  </ul>
</div>